// `ballio.settings` schema migration (ui-flow §14.1): a stored object whose `v` differs from the
// current version is migrated here before field-by-field normalisation (unknown or missing fields
// fall back to the defaults there).
//
// Implemented fully (contracts step). Consumer: settings/store.ts.

export const SETTINGS_VERSION = 1;

/**
 * Brings a parsed `ballio.settings` object to the current version. v1 is the first version, so
 * any other `v` (missing, older, newer, garbage) keeps its fields as they are and is stamped v1;
 * normalisation then drops whatever is invalid. Add one step per future version bump here.
 *
 * Adding a field needs no step and no bump: a stored object without it takes the default during
 * normalisation (the parity pass added `touchDirectionOnTouch`, `labelCurrency` and `moreOpen`
 * this way). Changing a default needs no step either: a stored object keeps the value it was
 * saved with (ui-qol §6, audio §6 — a migration must never overwrite a stored choice). A bump is
 * only for renames, type changes or reinterpretations of a stored field.
 */
export function migrateSettings(raw: Record<string, unknown>): Record<string, unknown> {
  if (raw['v'] === SETTINGS_VERSION) return raw;
  return { ...raw, v: SETTINGS_VERSION };
}
